var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocaleJaJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H3.75C2.09315 3 0.75 4.34315 0.75 6V18C0.75 19.6569 2.09315 21 3.75 21H20.25C21.9069 21 23.25 19.6569 23.25 18V6C23.25 4.34315 21.9069 3 20.25 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    fill: "#AE232F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.25 3H3.75C2.09325 3 0.75 4.34325 0.75 6V18C0.75 19.6568 2.09325 21 3.75 21H20.25C21.9068 21 23.25 19.6568 23.25 18V6C23.25 4.34325 21.9068 3 20.25 3ZM22.5 18C22.5 19.2405 21.4905 20.25 20.25 20.25H3.75C2.5095 20.25 1.5 19.2405 1.5 18V6C1.5 4.7595 2.5095 3.75 3.75 3.75H20.25C21.4905 3.75 22.5 4.7595 22.5 6V18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleJaJp);
export default __webpack_public_path__ + "static/media/icon-locale-ja-JP.0f5d5681cc0cfab5c0720675e20810ee.svg";
export { ForwardRef as ReactComponent };